import styled from "styled-components"

export const Container = styled.div`
  background-color: white;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.08);
`
